import * as React from "react";
import type { SVGProps } from "react";
const SvgGarageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M.56 3.36v5.6h1.12v15.68H2.8V8.96h22.4v15.68h1.12V8.96h1.12v-5.6zm1.12 1.12h24.64v3.36H1.68zm2.8 1.12v1.12H5.6V5.6zm3.36 0v1.12h1.12V5.6zm3.36 0v1.12h5.6V5.6zm7.84 0v1.12h1.12V5.6zm3.36 0v1.12h1.12V5.6zm-11.486 6.16c-1.14 0-2.17.696-2.597 1.752l-.923 2.29-.405.403a2.8 2.8 0 0 0-.829 1.989v5.326c0 .613.508 1.12 1.12 1.12h.56c.613 0 1.12-.507 1.12-1.12v-.332c1.18.164 2.662.332 5.04.332s3.861-.168 5.04-.332v.332c0 .613.508 1.12 1.12 1.12h.56c.613 0 1.12-.507 1.12-1.12v-5.326c0-.746-.297-1.464-.829-1.989l-.405-.402-.923-2.29a2.805 2.805 0 0 0-2.596-1.753zm0 1.12h6.173c.686 0 1.299.416 1.557 1.052l.967 2.398q.043.105.127.188l.486.483c.317.315.496.744.496 1.192v5.327h-.56v-.927a.558.558 0 0 0-.65-.553c-1.11.178-2.876.36-5.51.36s-4.399-.181-5.51-.36a.558.558 0 0 0-.65.553v.927h-.56v-5.326c0-.449.18-.878.497-1.193l.485-.483a.6.6 0 0 0 .127-.188l.967-2.398a1.68 1.68 0 0 1 1.558-1.052m-1.674 5.6a.84.84 0 1 0 0 1.68.84.84 0 0 0 0-1.68m9.52 0a.84.84 0 1 0 0 1.68.84.84 0 0 0 0-1.68m-7 .56v1.12h4.48v-1.12z"
    />
  </svg>
);
export default SvgGarageIcon;
